const header = document.querySelector("[data-header]");
const menuToggle = document.querySelector("[data-menu-toggle]");
const toast = document.querySelector("[data-toast]");
const cartCount = document.querySelector("[data-cart-count]");
const mobileBar = document.querySelector("[data-mobile-bar]");
let toastTimer;

function showToast(message) {
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add("is-visible");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove("is-visible"), 2200);
}

async function updateCartCount() {
  if (!cartCount) return;
  try {
    const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!response.ok) return;
    const cart = await response.json();
    cartCount.textContent = String(cart.item_count || 0);
  } catch {
    // Normal form fallback still works if AJAX cart is unavailable.
  }
}

document.querySelectorAll("[data-ajax-cart]").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const button = form.querySelector("button[type='submit']");
    button?.setAttribute("disabled", "disabled");

    try {
      const response = await fetch(form.action || "/cart/add", {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
      });

      if (!response.ok) throw new Error("Cart add failed");
      await updateCartCount();
      showToast("Added to cart");
    } catch {
      form.submit();
    } finally {
      button?.removeAttribute("disabled");
    }
  });
});

document.querySelectorAll(".size-grid button:not([data-variant-id])").forEach((button) => {
  button.addEventListener("click", () => {
    const grid = button.closest(".size-grid");
    grid?.querySelectorAll("button").forEach((item) => item.classList.remove("is-active"));
    button.classList.add("is-active");
  });
});

function bindVariantButtons(scope = document) {
  scope.querySelectorAll(".size-grid button[data-variant-id]").forEach((button) => {
    if (button.dataset.variantBound === "true") return;
    button.dataset.variantBound = "true";
    button.addEventListener("click", () => {
      const form = button.closest("form");
      const input = form?.querySelector("[data-variant-input]");
      if (!form || !input) return;
      const panel = form.closest(".purchase-panel");
      const price = panel?.querySelector("[data-product-price]");
      const submit = form.querySelector("[data-add-to-cart-text]");
      const available = button.dataset.variantAvailable !== "false";

      form.querySelectorAll(".size-grid button").forEach((item) => item.classList.remove("is-active"));
      button.classList.add("is-active");
      input.value = button.dataset.variantId;
      if (price && button.dataset.variantPrice) price.textContent = button.dataset.variantPrice;
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.addLabel || "Add to cart" : submit.dataset.soldOutLabel || "Sold out";
      }
    });
  });
}

bindVariantButtons();

document.querySelectorAll(".finder-choice").forEach((button) => {
  button.addEventListener("click", () => {
    const card = document.querySelector(".recommendation");
    if (!card) return;

    document.querySelectorAll(".finder-choice").forEach((item) => item.classList.remove("is-active"));
    button.classList.add("is-active");

    const points = (button.dataset.recPoints || "")
      .split("|")
      .map((point) => point.trim())
      .filter(Boolean);

    card.classList.add("is-changing");
    window.setTimeout(() => {
      const image = document.querySelector("[data-rec-image]");
      if (image && button.dataset.recImage) {
        image.src = button.dataset.recImage;
        image.alt = button.dataset.recTitle || "Recommended ring";
      }
      document.querySelector("[data-rec-kicker]").textContent = button.dataset.recKicker || "";
      document.querySelector("[data-rec-title]").textContent = button.dataset.recTitle || "";
      document.querySelector("[data-rec-body]").textContent = button.dataset.recBody || "";
      document.querySelector("[data-rec-list]").innerHTML = points.map((point) => `<li>${point}</li>`).join("");
      card.classList.remove("is-changing");
    }, 170);
  });
});

document.querySelectorAll("[data-gallery-src]").forEach((button) => {
  button.addEventListener("click", () => {
    const layout = button.closest(".builder-layout") || document;
    const target = layout.querySelector("[data-gallery-main]");
    const frame = layout.querySelector(".main-product-image");
    if (!target || !frame) return;

    layout.querySelectorAll("[data-gallery-src]").forEach((item) => item.classList.remove("is-active"));
    button.classList.add("is-active");

    frame.classList.add("is-changing");
    window.setTimeout(() => {
      target.src = button.dataset.gallerySrc;
      if (button.dataset.builderTitle) target.alt = button.dataset.builderTitle;
      frame.classList.remove("is-changing");
    }, 160);
  });
});

document.querySelectorAll("[data-builder-product]").forEach((button) => {
  button.addEventListener("click", () => {
    const layout = button.closest(".builder-layout");
    const panel = layout?.querySelector(".purchase-panel");
    const form = panel?.querySelector("form");
    const sizeGrid = panel?.querySelector("[data-builder-size-grid]");
    const title = panel?.querySelector("[data-builder-title-target]");
    const summary = panel?.querySelector("[data-builder-summary-target]");
    const price = panel?.querySelector("[data-builder-price-target]");
    const input = form?.querySelector("[data-variant-input]");
    const submit = form?.querySelector("[data-add-to-cart-text]");
    if (!layout || !panel || !form || !sizeGrid || !input) return;

    const ids = (button.dataset.builderVariantIds || "").split("|").filter(Boolean);
    const titles = (button.dataset.builderVariantTitles || "").split("|");
    const prices = (button.dataset.builderVariantPrices || "").split("|");
    const available = (button.dataset.builderVariantAvailable || "").split("|");
    const firstAvailableIndex = Math.max(0, available.findIndex((item) => item !== "false"));

    if (title) title.textContent = button.dataset.builderTitle || "";
    if (summary) summary.textContent = button.dataset.builderSummary || "";
    if (price) price.textContent = prices[firstAvailableIndex] || button.dataset.builderPrice || "";
    if (ids[firstAvailableIndex]) input.value = ids[firstAvailableIndex];

    sizeGrid.innerHTML = ids
      .map((id, index) => {
        const isAvailable = available[index] !== "false";
        const isActive = index === firstAvailableIndex ? " is-active" : "";
        const disabled = isAvailable ? "" : " disabled";
        return `<button type="button" class="${isActive.trim()}" data-variant-id="${id}" data-variant-price="${prices[index] || ""}" data-variant-available="${isAvailable ? "true" : "false"}"${disabled}>${titles[index] || ""}</button>`;
      })
      .join("");

    bindVariantButtons(sizeGrid);
    if (submit) {
      const currentAvailable = available[firstAvailableIndex] !== "false";
      submit.disabled = !currentAvailable;
      submit.textContent = currentAvailable ? submit.dataset.addLabel || "Add to cart" : submit.dataset.soldOutLabel || "Sold out";
    }
  });
});

document.querySelectorAll("[data-tilt]").forEach((card) => {
  card.addEventListener("pointermove", (event) => {
    const rect = card.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;
    card.style.setProperty("--tilt-x", `${y * -3}deg`);
    card.style.setProperty("--tilt-y", `${x * 3}deg`);
  });

  card.addEventListener("pointerleave", () => {
    card.style.setProperty("--tilt-x", "0deg");
    card.style.setProperty("--tilt-y", "0deg");
  });
});

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.16 }
);

document.querySelectorAll(".reveal").forEach((element) => observer.observe(element));
document.querySelectorAll(".hero .reveal").forEach((element) => element.classList.add("is-visible"));

function syncChrome() {
  document.body.classList.toggle("is-scrolled", window.scrollY > 8);
  document.body.classList.toggle("show-mobile-bar", Boolean(mobileBar) && window.scrollY > 520);
}

window.addEventListener("scroll", syncChrome, { passive: true });
syncChrome();

menuToggle?.addEventListener("click", () => {
  document.body.classList.toggle("nav-open");
});

document.querySelectorAll('a[href^="#"], a[href*="/#"]').forEach((link) => {
  link.addEventListener("click", () => {
    document.body.classList.remove("nav-open");
  });
});
